module.exports = {
  available: false,
  slug: "kauai2019",
  name: "Kauai",
  year: "2019",
  region: "Hawaii",
  country: "United States",
  location: "Kauai, Hawaii",
  subscriptionFee: 80,
  taxesAndFees: 600,
  soldOut: true,
  useHawaiiPricing: false,
  useHawaiiPhoneGate: false,
  soldOutPercent: 100,
  soldOutPercentHawaii: 100,
  soldOutReferralTrip: 'cancun2020',
  soldOutReferralText: 'Cancun Trip Added',
  banners: [''],
  saleEndsAt: '',
  thinBar1: '',
  thinBar2: '',
  onLocationPricingAvailable: false,
  onLocationPricingCutoff: "2018-09-29T06:00:00",
  onLocationMessage: "",
  requireFirstNameForNewsletter: true,
  requireLastNameForNewsletter: true,
  requireFirstNameForNewsletterFooter: true,
  requireLastNameForNewsletterFooter: true,
  allowPayChangeDuringCheckout: false,
  dates: "May 26 - June 1, 2019",
  timeZone: "HST",
  startTime: "7:30 PM (HST)",
  checkInDay: "Sunday",
  checkInDate: "May 26, 2019",
  checkInTime: "4:00 PM (HST)",
  arrivePriorTo: "4:30 PM (HST)",
  checkOutDay: "Saturday",
  checkOutDate: "June 1, 2019",
  checkOutTime: "11:00 AM (HST)",
  disableMonthlyPaymentOption: false,
  maxSubMonths: 6,
  useMaxSubMonthsCutoff: "12-15-2018",
  availabilityCutoff: "05-25-2019",
  departureAirport: "Lihue",
  departureAirCode: "LIH",
  venue: "Grand Hyatt Kauai",
  venueSlug: "grand-hyatt-kauai",
  homeVideoId: 235191435,
  requestBrochureCategoryID: "17c79e7b80",
  finalDetailsFormHash: "z1em16xq1pbcwdw",
  mapUrl: "https://www.google.com/maps/place/Grand+Hyatt+Kauai+Resort+and+Spa/@21.8749881,-159.4398268,15.22z/data=!4m16!1m8!3m7!1s0x7c071a8dbc3559a3:0xa58bb3a68dd11846!2sGrand+Hyatt+Kauai+Resort+and+Spa!5m1!1s2018-05-13!8m2!3d21.8760842!4d-159.4393058!3m6!1s0x7c071a8dbc3559a3:0xa58bb3a68dd11846!5m1!1s2018-05-13!8m2!3d21.8760842!4d-159.4393058",
  perks: [
    "7 Days / 6 Nights Grand Hyatt Kauai Resort & Spa Accommodations",
    "$35 Daily Resort Fee (Self-Parking, High-Speed Internet, Access to 24 hour Anara Spa Fitness Center, Fitness Classes, Coffee Maker in Room with Hawaiian Coffee and Tea, Two Complimentary Refillable Water Bottles with Purified Water Stations, Guided Sunrise Walk, Torch Lighting Ceremony, Ukulele, Lei-making, and Hula Lessons, and more!)",
    "Porterage Fees (Baggage Handling)",
    "Everlasting Tours On-Location Staff",
    "Entertainment Wristbands ($500 value per person, included!)"
  ],
  subPerks: [
    "Speaking Sessions by Phenomenal Christian Speakers",
    "Performances by Chart Topping Christian Artists",
    "Morning Worship led by Musical Artists",
    "Meet & Greet Sessions with Speakers & Artists"
  ],
  lineup: [
    {
      key: "jeremycamp",
      kind: "speaker",
      name: "Jeremy Camp",
      nameFirst: "Jeremy",
      nameLast: "Camp"
    }, {
      key: "newsboys",
      kind: "artist",
      name: "Newsboys",
      nameFirst: "Newsboys",
      nameLast: ""
    }, {
      key: "jonforeman",
      kind: "artist",
      name: "Jon Foreman of Switchfoot",
      nameFirst: "Jon Foreman",
      nameLast: "of Switchfoot"
    }, {
      key: "adiecamp",
      kind: "speaker",
      name: "Adie Camp",
      nameFirst: "Adie",
      nameLast: "Camp"
    }, {
      key: "bobgoff",
      kind: "speaker",
      name: "Bob Goff",
      nameFirst: "Bob",
      nameLast: "Goff",
      book: "love-does"
    }, {
      key: "troytyler",
      kind: "speaker",
      name: "Troy Tyler",
      nameFirst: "Troy",
      nameLast: "Tyler"
    }
  ],
  itinerary: [
    {
      name: "Sun",
      body: "\
        <p>\
          <strong>Day 1 | May 26</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>\
            Resort Check-in & Love Song Registration\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>\
            Grand Opening with Troy Tyler\
          </strong>\
        </p>\
      "
    }, {
      name: "Mon",
      body: "\
        <p>\
          <strong>Day 2 | May 27</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship & Bob Goff Speaking Session 1 & 2\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Date Night in Paradise*</strong>\
        </p>\
      "
    }, {
      name: "Tue",
      body: "\
        <p>\
          <strong>Day 3 | May 28</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship & Bob Goff Speaking Session 3 & 4\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Starry Nights Social*</strong>\
        </p>\
      "
    }, {
      name: "Wed",
      body: "\
        <p>\
          <strong>Day 4 | May 29</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Worship, Devotion, & Communion</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Newsboys Performance</strong>\
        </p>\
      "
    }, {
      name: "Thu",
      body: "\
        <p>\
          <strong>Day 5 | May 30</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Optional Activity – Love Song Interactive*</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>\
      "
    }, {
      name: "Fri",
      body: "\
        <p>\
          <strong>Day 6 | May 31</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Worship, Devotion, & Communion</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
      <strong>\
        Jon Foreman of Switchfoot Performance &<br />\
        Jeremy Camp Performance\
      </strong>\
        </p>\
      "
    }, {
      name: "Sat",
      body: "\
        <p>\
          <strong>Day 7 | June 1</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Resort Checkout</strong>\
        </p>\
      "
    }
  ],
  useCoupons: false,
  couponDisplay: 1,
  coupons: [
  ],
  rooms: {
    "standard": {
      key: "standard",
      name: "Standard Room",
      kind: "room",
      trip: "kauai2019",
      upsell: "pool",
      prices: {
        default: 4598,
        hawaii: 3798,
        onlocation: 3898
      },
      extraNightPrices: {
        default: 400,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-standard.jpg",
      header: "/images/rooms/kauai2019-standard.jpg",
      description: "500 sqft. limited view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "standard-king": {
      key: "standard-king",
      name: "Standard Room - King Guaranteed",
      kind: "room",
      trip: "kauai2019",
      upsell: "partial-ocean-king",
      prices: {
        default: 4798,
        hawaii: 3998,
        onlocation: 4198
      },
      extraNightPrices: {
        default: 425,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-standard-king.jpg",
      header: "/images/rooms/kauai2019-standard-king.jpg",
      description: "500 sqft. limited view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "pool": {
      key: "pool",
      name: "Pool View",
      kind: "room",
      trip: "kauai2019",
      upsell: "partial-ocean",
      prices: {
        default: 4798,
        hawaii: 3998,
        onlocation: 4398
      },
      extraNightPrices: {
        default: 450,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-pool.jpg",
      header: "/images/rooms/kauai2019-pool.jpg",
      description: "500 sqft. pool view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "pool-king": {
      key: "pool-king",
      name: "Pool View - King Guaranteed",
      kind: "room",
      trip: "kauai2019",
      upsell: 'partial-ocean-king',
      prices: {
        default: 4998,
        hawaii: 4198,
        onlocation: 4598
      },
      extraNightPrices: {
        default: 475,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-pool-king.jpg",
      header: "/images/rooms/kauai2019-pool-king.jpg",
      description: "500 sqft. pool view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "partial-ocean": {
      key: "partial-ocean",
      name: "Partial Ocean View",
      kind: "room",
      trip: "kauai2019",
      upsell: "partial-ocean-king",
      prices: {
        default: 5198,
        hawaii: 4198,
        onlocation: 4598
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-partial-ocean.jpg",
      header: "/images/rooms/kauai2019-partial-ocean.jpg",
      description: "500 sqft. ocean view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "partial-ocean-king": {
      key: "partial-ocean-king",
      name: "Partial Ocean View - King Guaranteed",
      kind: "room",
      trip: "kauai2019",
      upsell: "deluxe-ocean-king",
      prices: {
        default: 5398,
        hawaii: 4398,
        onlocation: 4898
      },
      extraNightPrices: {
        default: 525,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-partial-ocean-king.jpg",
      header: "/images/rooms/kauai2019-partial-ocean-king.jpg",
      description: "500 sqft. ocean view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "deluxe-ocean": {
      key: "deluxe-ocean",
      name: "Deluxe Ocean View",
      kind: "room",
      trip: "kauai2019",
      upsell: "deluxe-ocean-king",
      prices: {
        default: 5798,
        hawaii: 4398,
        onlocation: 5198
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: true,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-deluxe-ocean.jpg",
      header: "/images/rooms/kauai2019-deluxe-ocean.jpg",
      description: "500 sqft. deluxe ocean view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "deluxe-ocean-king": {
      key: "deluxe-ocean-king",
      name: "Deluxe Ocean View - King Guaranteed",
      kind: "room",
      trip: "kauai2019",
      upsell: false,
      prices: {
        default: 5998,
        hawaii: 4598,
        onlocation: 5598
      },
      extraNightPrices: {
        default: 575,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-deluxe-ocean-king.jpg",
      header: "/images/rooms/kauai2019-deluxe-ocean-king.jpg",
      description: "500 sqft. deluxe ocean view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer."
    },
    "standard-suite": {
      key: "standard-suite",
      name: "Standard Suite",
      kind: "suite",
      trip: "kauai2019",
      upsell: false,
      prices: {
        default: 8998,
        hawaii: 7998,
        onlocation: 7998
      },
      extraNightPrices: {
        default: 950,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-standard-suite.jpg",
      header: "/images/rooms/kauai2019-standard-suite.jpg",
      description: "1055 - 1376 standard suite, one King, private lanai, separate sitting area, marble bathroom, double sink, a walk-in shower, and Hawaiian classic décor.   Room amenities include: Spa tub, work desk, dining table for 4, 42” flat panel LCD TV, small chiller, robes, coffee maker, in-room safe."
    },
    "ocean-view-suite": {
      key: "ocean-view-suite",
      name: "Ocean View Suite",
      kind: "suite",
      trip: "kauai2019",
      upsell: "deluxe-ocean-view-suite",
      prices: {
        default: 9998,
        hawaii: 9998,
        onlocation: 8998
      },
      extraNightPrices: {
        default: 1250,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-ocean-view-suite.jpg",
      header: "/images/rooms/kauai2019-ocean-view-suite.jpg",
      description: "1050 - 1084 ocean view suite, one King, private lanai, separate sitting area, marble bathroom, double sink, a walk-in shower, and Hawaiian classic décor.   Room amenities include: Spa tub, work desk, dining table for 4, 42” flat panel LCD TV, small chiller, robes, coffee maker, in-room safe."
    },
    "deluxe-ocean-view-suite": {
      key: "deluxe-ocean-view-suite",
      name: "Deluxe Ocean View Suite",
      kind: "suite",
      trip: "kauai2019",
      upsell: false,
      prices: {
        default: 14998,
        hawaii: 10598,
        onlocation: 11598
      },
      extraNightPrices: {
        default: 1500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "Sold Out",
      image: "/images/rooms/kauai2019-deluxe-ocean-view-suite.jpg",
      header: "/images/rooms/kauai2019-deluxe-ocean-view-suite.jpg",
      description: "1317 - 1877 deluxe suite, one King, private lanai, sitting area, marble bathroom, double sink, a walk-in shower, and Hawaiian classic décor.   Room amenities include: Whirlpool tub, work desk, dining table for 6, 42” flat panel LCD TV, small chiller, robes, coffee maker, in-room safe."
    }
  }
}



// WEBPACK FOOTER //
// ./lib/trips/kauai2019.js